import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { EfaactDynamicDataService } from '../../efaact.dynamic-data-service';
import { DRStatus } from './dr-status.model';

export const entityName = 'supervisorgraph';

@Injectable()
export class DRStatusDataService extends EfaactDynamicDataService<DRStatus> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(
            http,
            httpUrlGenerator,
            entityName,
            log,
            { ...config, root: `${config.root}/dashboard` },
            store
        );
    }

    mapItems(item: DRStatus): DRStatus {
        if (!item) {
            return;
        }
        return {
            ...item,
            id: item.Name_Task
        };
    }
}
